export const mainColor = state => {
    // return 'rgb(26, 188, 156)'
    console.log('ss', state)
    return '#323746'
}